import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "@mui/material";
import MenuIcon from "../Icons/Menu.svg";
import EiLogo from "../Icons/EiLogo.svg";
import { useSelector } from "react-redux";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import { getToken } from "../services/Token";
import { useNavigate } from "react-router-dom";
import { Disclosure } from "@headlessui/react";
import { ChevronUpIcon } from "@heroicons/react/24/solid";

const Sidebar = ({
  showSidebar,
  handleSidebarToggle,
  handleClick,
  navigation,
}) => {
  const logoUrl = useSelector((state) => state.calendar.logoUrl);
  const employeeName = getToken("employeeName");
  const role = getToken("roles");
  const isAdmin = role ? role.includes("ADMIN") : false;
  const navigate = useNavigate();
  const { isAnnouncementOpen } = useSelector((state) => state.notification);

  return (
    <div id="containerSidebar" className="z-50">
      <div className="navbar-menu relative z-50">
        <nav
          id="sidebar"
          className={`fixed h-full flex w-3/4 flex-col pb-40 ${
            isAnnouncementOpen ? "top-14" : "top-0"
          } inset-y-0 overflow-x-hidden overflow-y-auto bg-white pb-2 sm:max-w-xs lg:w-80 border-r border-gray-200 z-50 ${
            showSidebar ? "translate-x-0" : "-translate-x-full"
          }`}
        >
          <div>
            <div className="flex flex-row items-center">
              <button
                type="button"
                className="text-xl text-white mr-2"
                onClick={handleSidebarToggle}
              >
                <div className="h-10 w-10 flex items-center justify-center rounded-full mt-[20px] ml-[50px]">
                  <img className="mr-[0.75rem]" src={MenuIcon} alt="Menu" />
                  <img className="ml-2" src={EiLogo} alt="ICON" />
                  <div className="text-center mb-[-2rem] mt-[-2rem] ml-2"></div>
                </div>
              </button>
              <h2 className="text-2xl font-serif text-purple-800 mt-3 ml-3 cursor-default">
                <span className="font-extrabold">work</span>
                <span className="font-extrabold">force</span>
                <span className="text-3xl font-extrabold text-blue-600">
                  HR
                </span>
              </h2>
            </div>
          </div>
          <div className="flex items-center p-5">
            <div className="">
              {logoUrl ? (
                <img className="w-10 h-10 " src={logoUrl} alt="logo" />
              ) : (
                <FontAwesomeIcon icon={faUser} className="w-10 h-10 " />
              )}
            </div>
            <div className="ml-5">
              <Tooltip title={employeeName}>
                <p className="text-[1rem] font-medium">
                  {employeeName ? (
                    employeeName.split("(")[0]
                  ) : (
                    <p className="text-sm">No data available</p>
                  )}
                </p>
              </Tooltip>

              {!isAdmin ? (
                <button
                  className="text-[#3944BC] cursor-pointer"
                  onClick={() => {
                    navigate("/profile");
                  }}
                >
                  View My Info
                </button>
              ) : (
                ""
              )}
            </div>
          </div>
          <div className="mt-5">
            <ul className="mt-3">
              {navigation.map((item) => {
                return (
                  <li key={item.name} className="mb-2">
                    <Disclosure defaultOpen={item.current}>
                      {({ open }) =>
                        item.isVisible && (
                          <>
                            <Disclosure.Button
                              onClick={() => handleClick(item)}
                              className={`${
                                item.current
                                  ? "bg-blue-400 bg-opacity-20 text-[#3944BC] w-full"
                                  : "text-gray-500 hover:bg-gray-200 "
                              }flex w-full  px-4 py-3 text-left text-sm font-medium focus:outline-none focus-visible:ring focus-visible:ring-gray-500 focus-visible:ring-opacity-75`}
                            >
                              <div className="flex justify-between items-center w-full">
                                <div className="flex items-center">
                                  <img
                                    className="mr-4 w-6 h-6"
                                    src={item.icon}
                                    alt="icon"
                                  />
                                  <span className="text-gray-600">
                                    {item.name}
                                  </span>
                                </div>
                                {item?.subItems?.length > 0 && (
                                  <div>
                                    <ChevronUpIcon
                                      className={`${
                                        open ? "rotate-180 transform" : ""
                                      } h-4 w-4 text-purple-500`}
                                    />
                                  </div>
                                )}
                              </div>
                            </Disclosure.Button>
                            <Disclosure.Panel className="ml-8 text-[#4E5664]">
                              <ul className="list-disc pl-2 my-3">
                                {item?.subItems
                                  ?.filter((subItem) => subItem.isVisible)
                                  .map((subItem) => (
                                    <button
                                      key={subItem.name}
                                      className={`ml-6 mt-1 cursor-pointer text-sm text-gray-600 hover:font-semibold  ${
                                        subItem.current
                                          ? "font-semibold text-[#171e75]"
                                          : ""
                                      }`}
                                      onClick={() => handleClick(subItem)}
                                    >
                                      <div className="flex">
                                      <img
                                        className="mr-4 w-6 h-6"
                                        src={subItem.icon}
                                        alt="icon"
                                      />
                                      {subItem.name}
                                      </div>
                                    </button>
                                  ))}
                              </ul>
                            </Disclosure.Panel>
                          </>
                        )
                      }
                    </Disclosure>
                  </li>
                );
              })}
            </ul>
          </div>
        </nav>
      </div>
      <div className="mx-auto lg:ml-80"></div>
    </div>
  );
};

export default Sidebar;
